import { accountDetails } from "@di";
import ContractReportRepository from "@adapters/repositories/Reports/ContractReport";
export default (http) => {
    return {
        contract: new ContractReportRepository(http, accountDetails),
    };
};
